import axios from 'axios'

import { COP_COMMON_ERROR_MESSAGES } from '../constants/common-error-messages'
import { ASSETS_BASE_ENDPOINT, COP_API_BASE_URL } from '../constants/service-endpoints'
import { ToastService } from './toast.service'
import { buildCopHeaders, getSilentToken } from './tokenUtils'

const CATEGORY_NAME_MAP: Record<number, string> = {
  1:  'microscada',
  2:  'ied',
  3:  'rtu',
  4:  'wireless',
  6:  'grid-and-power-quality-system',
  13: 'gis-transmission',
  14: 'gis-sub-transmission',
  15: 'pass-hybrids',
  16: 'live-tank-circuit-breakers',
  17: 'dead-tank-circuit-breakers',
  18: 'generator-circuit-breakers',
  19: 'hvdc-transformers',
  20: 'industrial-special-transformers',
  21: 'power-transformers',
  22: 'reactors',
  23: 'software-assets',
  24: 'offshore-transformers',
}

export interface ExportAssetListParams {
  functionName: string
  categoryId: number
  exportType: 'Excel' | 'PDF'
}

export async function exportAssetListByProductCategory(
  params: ExportAssetListParams,
): Promise<void> {
  const { functionName, categoryId, exportType } = params

  try {
    const token = getSilentToken()
    const url = `${COP_API_BASE_URL}${ASSETS_BASE_ENDPOINT}/${functionName}(categoryId=${categoryId},exportType='${exportType}')`
    const headers = buildCopHeaders(token)

    const response = await axios.get<Blob>(url, { headers, responseType: 'blob' })

    const categoryName = CATEGORY_NAME_MAP[categoryId] ?? 'assets'
    const blob = new Blob([response.data], { type: response.headers['content-type'] as string })
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = `${categoryName}-assets-list.${exportType === 'Excel' ? 'xlsx' : 'pdf'}`
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(objectUrl)
  } catch (error) {
    const fallbackMessage = COP_COMMON_ERROR_MESSAGES['api-error'].message.replace(
      '{{action}}',
      COP_COMMON_ERROR_MESSAGES['api-error'].action['assets-exporting'],
    )
    const message = error instanceof Error && error.message ? error.message : fallbackMessage
    ToastService.error(message)
  }
}

